module.exports = __webpack_public_path__ + "img/003.57ab508f.png";